module.exports = __webpack_public_path__ + "static/media/HCRA Notice of Proposal re Compliance Order - OSMI9 - August 8, 2024.1915a8e0.pdf";